import { alpha, Box, Typography } from "@mui/material";

const SelectedRunBanner = ({ run, onClick }) => {
  if (!run) return null;

  return (
    <Box
      onClick={onClick}
      sx={(theme) => ({
        mb: 1,
        p: 1,
        borderRadius: 1.5,
        cursor: "pointer",
        bgcolor: alpha(theme.palette.primary.main, 0.12),
        borderLeft: `3px solid ${theme.palette.primary.main}`,
        "&:hover": {
          bgcolor: alpha(theme.palette.primary.main, 0.2),
        },
      })}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          display: "block",
          lineHeight: 1.2,
          fontSize: "0.7rem",
          textTransform: "uppercase",
          letterSpacing: 0.5,
        }}
      >
        Now viewing
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {run.name}
      </Typography>
    </Box>
  );
};

export default SelectedRunBanner;
